import { MaybeRef, Ref, unref, watch } from 'vue';
import { GetColumnWidthsUseCase } from '../BaseTableContent/useCases/getColumnWidthsUseCase';
import { TableType } from '@/coreDomainsModule/table';

/**
 * テーブル列幅を管理するcomposable
 * @param columnWidthItem - useColumnResizerの初期化パラメータ
 * @returns 列幅初期化メソッド
 */
export const useColumnWidth = (columnWidthItem: ColumnWidthItem) => {
  let requestId = 0;
  /**
   * テーブル列幅を取得する
   * @returns - テーブルヘッダー情報 or undefined
   */
  const initializeTableColumnsWidth = async (): Promise<void> => {
    const currentRequestId = ++requestId;
    const currentTableType = unref(columnWidthItem.tableType);

    columnWidthItem.widthInfo.value = {};

    const getColumnWidthsUseCase = new GetColumnWidthsUseCase();
    const columnWidthResult = await getColumnWidthsUseCase.Execute(unref(columnWidthItem.tableType));

    if (currentRequestId !== requestId || currentTableType !== unref(columnWidthItem.tableType)) return;

    if (columnWidthResult.status.type === 'success') {
      columnWidthItem.widthInfo.value = columnWidthResult.status.data ?? {};
    } else {
      console.error('ヘッダー情報取得エラー: 列幅情報が取得できていません。');
    }
  };

  watch(
    () => unref(columnWidthItem.tableType),
    () => initializeTableColumnsWidth(),
    { immediate: true }
  );

  return {
    initializeTableColumnsWidth,
  };
};

/**
 * useColumnResizerの初期化パラメータ
 * @param tableType - テーブル種別
 * @param keys - 列キー配列
 * @param widthInfo - 列幅情報のRef
 * @param headerClassName - ヘッダー要素のクラス名
 * @param tableEl - テーブル要素のRef（HTMLElementまたはVueコンポーネントインスタンス）
 */
export type ColumnWidthItem = {
  tableType: MaybeRef<TableType>;
  widthInfo: Ref<Record<string, number | undefined>>;
};
